export default "/images/e380c0261d7309d660ad1c28621c0d62.avif";